module.exports = __webpack_public_path__ + "img/15.b0fafc8.jpg";